export default __webpack_public_path__ + "static/media/css3.bb2ffdb2.png";